import request from '../../src/state/modules/axios'

export function getPlaces(){
    return request({
        url: '/api/workplace-employments',
        method: 'get',
    })
}

export function getPlacesById(data){
    return request({
        url: `/api/workplace-employments/${data.id}`,
        method: 'get',
    })
}

export function addPlaces(data){
    return request({
        url: '/api/workplace-employments',
        method: 'post',
        data,
    })
}

export function editPlaces(data){
    return request({
        url: `/api/workplace-employments/${data.id}`,
        method: 'put',
        data,
    })
}

export function deletePlaces(data){
    return request({
        url: `/api/workplace-employments/${data.id}`,
        method: 'delete'
    })
}